import { HtmlUtilities } from "./IsiWebGUI/IsiFW/IsiFW.ui.core";
import { IsiXmlUserSettings } from "./Xml/XmlUserSettings";

export class XmlUtilities {

    private constructor() { }

    /**
     * Recherche les caractères d'ouverture et de fermuture de balises XML afin de les remplacer par leurs équivalents d'entité HTML
     * @param str Chaîne de caractères à traiter
     */
    public static encodeIllegalChars(str: string): string {
        let result: string = str;

        const regex = /(>[^<>]*)(<|>|<>)([^<>]*<)/gm;
        let match: any;

        while ((match = regex.exec(result)) !== null) {
            if (match.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            const replaceValue: string = match[1] + HtmlUtilities.encode(match[2]) + match[3];
            result = result.replace(match[0], replaceValue);
        }

        return result;
    }

    /**
     * Construction de l'objet de calcul des valdef xml.
     * @returns
     */
    public static buildXmlUserSettings(): IsiXmlUserSettings {
        return new IsiXmlUserSettings();
    }
}
